import { createStore } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import globalReducer from './globalReducer';

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, globalReducer)
// Let reducers define initial shape; rehydration handled by PersistGate
const store = createStore(persistedReducer)

window.getState = () => store.getState();

export default store;
